import type { RouteRecordRaw } from "vue-router";

const Layout = () => import("@/layout/index.vue");

const aiClassRoomRoutes: RouteRecordRaw = {
  path: "/aiClassRoom",
  component: Layout,
  redirect: "/aiClassRoom/bookList",
  name: "AiClassRoom",
  meta: {
    title: "AI课堂",
    icon: "homepage",
    permissionKey: "aiClassRoom",
  },
  children: [
    {
      path: "bookList",
      name: "AiClassRoomBookList",
      component: () =>
        import("@/views/Workbench/ai-class-room/book-list/index.vue"),
      meta: {
        title: "教材管理",
        icon: "homepage",
        permissionKey: "aiClassRoom:bookList",
      },
    },
    {
      path: "wordList",
      name: "AiClassRoomWordList",
      component: () =>
        import("@/views/Workbench/ai-class-room/word-list/index.vue"),
      meta: {
        title: "单词管理",
        icon: "homepage",
        permissionKey: "aiClassRoom:wordList",
      },
    },
    {
      path: "question",
      name: "AiClassRoomQuestionManagement",
      component: () =>
        import("@/views/Workbench/ai-class-room/question/index.vue"),
      meta: {
        title: "题目管理",
        icon: "homepage",
        permissionKey: "aiClassRoom:question",
      },
    },
  ],
};

export default aiClassRoomRoutes;
